const topScript = () => {

  (function(d) {
    var config = {
      kitId: 'gnw0vuu',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
    })(document);

  (function (d) {
    var config = {
        kitId: 'gnw0vuu',
        scriptTimeout: 3000,
        async: true
      },
      h = d.documentElement,
      t = setTimeout(function () {
        h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
      }, config.scriptTimeout),
      tk = d.createElement("script"),
      f = false,
      s = d.getElementsByTagName("script")[0],
      a;
    h.className += " wf-loading";
    tk.src = 'https://use.typekit.net/' + config.kitId + '.js';
    tk.async = true;
    tk.onload = tk.onreadystatechange = function () {
      a = this.readyState;
      if (f || a && a != "complete" && a != "loaded") return;
      f = true;
      clearTimeout(t);
      try {
        Typekit.load(config)
      } catch (e) {}
    };
    s.parentNode.insertBefore(tk, s)
  })(document);

  // イメージマップ
  $(document).ready(function(e) {
      $('img[usemap]').rwdImageMaps();
  });
  // イメージマップ

  // メインビューSlick
  $('.main-view-slick').slick({
    autoplay: true,
    centerMode: true,
    centerPadding: '23.4375vw',
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: 'linear',
    dots: false,
    fade: false,
    slidesToShow: 1,
    swipeToSlide: true,
    touchMove: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    responsive: [{
        breakpoint: 1370,
        settings: {
          centerPadding: '20vw',
        }
      },
      {
        breakpoint: 667,
        settings: {
          centerPadding: '5vw',

        }
      },
    ]

  });

  $('.top-slider-list').slick({
    autoplay: true,
    autoplaySpeed: 0,
    arrows: false,
    cssEase: 'linear',
    dots: false,
    fade: false,
    pauseOnHover: false,
    slidesToShow: 3,
    speed: 10000
  });
  // スライダー

  // よくある質問
  $(function (){
    $('.top-qa-content-list li.li-1').click(function(){
      $(this).toggleClass('now');
      $('.top-qa-content-list li').not(this).removeClass('now');
      $('.top-qa-content-in.con-1').addClass('now');
      $('.top-qa-content-in').not('.top-qa-content-in.con-1').removeClass('now');
    });
    $('.top-qa-content-list li.li-2').click(function(){
      $(this).toggleClass('now');
      $('.top-qa-content-list li').not(this).removeClass('now');
      $('.top-qa-content-in.con-2').addClass('now');
      $('.top-qa-content-in').not('.top-qa-content-in.con-2').removeClass('now');
    });
    $('.top-qa-content-list li.li-3').click(function(){
      $(this).toggleClass('now');
      $('.top-qa-content-list li').not(this).removeClass('now');
      $('.top-qa-content-in.con-3').addClass('now');
      $('.top-qa-content-in').not('.top-qa-content-in.con-3').removeClass('now');
    });
    $('.top-qa-content-list li.li-4').click(function(){
      $(this).toggleClass('now');
      $('.top-qa-content-list li').not(this).removeClass('now');
      $('.top-qa-content-in.con-4').addClass('now');
      $('.top-qa-content-in').not('.top-qa-content-in.con-4').removeClass('now');
    });
    $('.top-qa-content-list li.li-5').click(function(){
      $(this).toggleClass('now');
      $('.top-qa-content-list li').not(this).removeClass('now');
      $('.top-qa-content-in.con-5').addClass('now');
      $('.top-qa-content-in').not('.top-qa-content-in.con-5').removeClass('now');
    });
    $('.top-qa-content-list li.li-6').click(function(){
      $(this).toggleClass('now');
      $('.top-qa-content-list li').not(this).removeClass('now');
      $('.top-qa-content-in.con-6').addClass('now');
      $('.top-qa-content-in').not('.top-qa-content-in.con-6').removeClass('now');
    });
  });

  // アコーディオン
  $(function(){
    $('.top-qa-content-in dl dd').hide();
    $('.top-qa-content-in dl dt').click(function(){
       $(this).next('.top-qa-content-in dl dd').slideToggle();
       $(this).toggleClass('open');
    });
  });

  // レスポンシブ関連
  $(function () {
    var windowWidth = $(window).width();
    var windowSm = 667;

    if (windowWidth <= windowSm) { // スマホ時のjQuery
      // 固定フッターの設定
      $(document).ready(function() {

        var kotei_foot = $('.kotei-foot-link');

        $(window).scroll(function () {
          if ($(this).scrollTop() > 200) {
            kotei_foot.addClass('fadein');
          } else {
            kotei_foot.removeClass('fadein');
          }
        });

      });

      $(function(){
        $(window).scroll(function (){
          $('.foot-in-logo-img').each(function(){
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight){
              $('.kotei-foot-link').removeClass('fadein');
            }
          });
        });
      });

    } else { // PC・タブレット時のjQuery

    }

  });
};

const sliderScript = () => {
  // スライダー
  $('.top-lineup-content-in-list').slick({
    autoplay: false,
    arrows: true,
    cssEase: 'linear',
    dots: false,
    fade: false,
    pauseOnHover: false,
    slidesToShow: 3,
    responsive: [{
      breakpoint: 1370,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 668,
      settings: {
        slidesToShow: 1
      }
    }]
  });
}

export default {
  sliderScript,
  topScript,
};